import { Injectable } from '@angular/core';
import { IS1SearchParams, IS1SimplePaginatedResult, S1HttpClientService } from '@app/s1';
import { map, Observable } from 'rxjs';
import { IMenuRole, IRole, IRoleFunction } from '../models/role';

export interface ISearchRuoloParams extends IS1SearchParams { }

export interface IAddFunctionParams {
  codRole: string,
  codFunction: string
}

export interface IRuoliPaginated extends IS1SimplePaginatedResult {
  ruoli: IRole[];
}

enum RoleApi {
  roles = "/roles",
  functions = "/menu/functions",
  function = "/menu/function"
}

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  private path = "/bo/admin/role";

  constructor(private s1HttpClient: S1HttpClientService) { }

  getRuoli(parameters: ISearchRuoloParams): Observable<IRuoliPaginated> {
    return this.s1HttpClient.get(`${this.path}${RoleApi.roles}`, parameters).pipe(
      map(response => {
        return {
          ruoli: response.data.results, total: response.data.total
        }
      })
    )
  }

  roleDetail(code: string): Observable<IRole> {
    return this.s1HttpClient.get(`${this.path}/${code}`).pipe(
      map(response => response.data)
    )
  }

  addRole(parameters: IRole): Observable<IRole> {
    return this.s1HttpClient.post(`${this.path}`, parameters).pipe(
      map(response => response.data)
    )
  }

  editRole(parameters: IRole): Observable<IRole> {

    const code = parameters.code;
    delete parameters.code;

    return this.s1HttpClient.put(`${this.path}/${code}`, parameters).pipe(
      map(response => response.data)
    )
  }

  delete(role: IRole): Observable<boolean> {
    return this.s1HttpClient.delete(`${this.path}/${role.code}`, true).pipe(
      map(response => response.outcome.success)
    )
  }

  getFunctions(): Observable<IRoleFunction[]> { 
    return this.s1HttpClient.get(`${this.path}${RoleApi.functions}`).pipe(
      map(response => response.data.results)
    )
  }

  addFunction(params: IAddFunctionParams): Observable<IMenuRole> { 
    return this.s1HttpClient.post(`${this.path}${RoleApi.function}`, params).pipe(
      map(response => response.data)
    )
  }

  deleteFunction(roleFunction: IMenuRole): Observable<boolean> {
    return this.s1HttpClient.delete(`${this.path}${RoleApi.function}/${roleFunction.idRoleFunction}`).pipe(
      map(response => response.outcome.success)
    )
  }

}
